import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

export const EmptyBatches: FC = () => {
  return (
    <div className="card">
      <div className="card-body h-200px d-flex align-items-center justify-content-center">
        <div>
          <FontAwesomeIcon icon={faInfoCircle} size="3x" className="mb-5 d-block text-muted mx-auto" />
          <h2>Select one or more filters to view available batches</h2>
        </div>
      </div>
    </div>
  );
};